<template>
  <div class="client-route-viewer">
    <v-layout align-center justify-space-between row fill-height>
      <div class="client-route-viewer__logo">
        <img src="@/assets/danckuts-logo-black.png" class="client-route-viewer__logo-img" alt="Danckuts">
      </div>
      <div>
        <button @click.prevent="logout">Logout</button>
      </div>
    </v-layout>

    <transition name="slide-fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  /********************
   *
   * This page is a passthrough for nested child routes for client views.
   *
   * Use this when the presenting pages to the client. The page will show a
   * danckuts logo in the upper left side with no other available links.
   *
   ********************/
  methods: {
    logout () {
      this.$store.dispatch('user/logout')
    }
  }
}
</script>

<style lang="scss">
.client-route-viewer {
  &__logo {
    &-img {
      width: 150px;
    }
  }

  .slide-fade-enter-active {
    transition: all .15s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
}
</style>
